import * as yup from 'yup';

export const RoleSchema = yup.object({
  relationship_id: yup.string().nullable(),
  role_id: yup.string(),
  permission_ids: yup.array().of(yup.string()),
});
export type Role = yup.InferType<typeof RoleSchema>;

export const UserPermissionsSchema = yup.object({
  object_permissions: yup.object({
    roles: yup.array().of(RoleSchema),
    related_permissions: yup.array().of(yup.object()),
  }),
  user_id: yup.string(),
  user_type: yup.string(),
});
export type UserPermissions = yup.InferType<typeof UserPermissionsSchema>;
